import { RiskRange, RiskRanges } from "../ranges";
import { Risk } from "../units";

function rangesFor({ age }: { age: number }) {
  if (age >= 60) {
    const ranges: RiskRange[] = [
      { from: 90, to: 160, risk: Risk.HighRisk, label: "high" },
      { from: 85, to: 90, risk: Risk.Risk, label: "moderate" },
      { from: 80, to: 85, risk: Risk.Normal, label: "normal" },
      { from: 50, to: 80, risk: Risk.Optimal, label: "optimal" },
      { from: 0, to: 50, risk: Risk.Risk, label: "moderate" },
    ];

    return new RiskRanges("mmHg", ranges);
  }

  const ranges: RiskRange[] = [
    { from: 90, to: 160, risk: Risk.HighRisk, label: "high" },
    { from: 85, to: 90, risk: Risk.Risk, label: "moderate" },
    { from: 80, to: 85, risk: Risk.Normal, label: "normal" },
    { from: 0, to: 80, risk: Risk.Optimal, label: "optimal" },
  ];

  return new RiskRanges("mmHg", ranges);
}

export const Diastolic = {
  rangesFor,
};
